import { useHistory, useLocation } from "react-router-dom";
import { useContext } from "react";
import { DueDateContext } from "../contexts/DueDateContext";
import { getISODateWithoutTime } from "../pages/utils/date.utils";
import { FE_TO_BE_VALUES, ROUTE_TO_FE_VALUE } from "../constants/app.constants";

import { WHOLESALE_PRICE_SUFFIX } from "../routes";
export const TERRITORY_PARAM = "territory";
export const COUNTRY_PARAM = "country";
export const CHANNEL_PARAM = "channel";
export const BUSINESS_MODEL_PARAM = "businessModel";
export const ACCOUNT_PARAM = "account";
export const PRODUCT_ENGINE_PARAM = "productEngine";
export const DISTRIBUTION_METHOD_PARAM = "distributionMethod";

export const ORDER_TYPE_PARAM = "orderType";
const useQueryParams = () => {
  const { shipmentMonthDate } = useContext(DueDateContext);
  const { pathname, search } = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(search);

  const setParameter = (parameterName: string, value: string) => {
    const parameter = queryParams.get(parameterName) ?? "";
    if (parameter.includes(value)) {
      queryParams.delete(parameterName);
    } else {
      queryParams.set(parameterName, value);
    }
    history.replace({
      pathname,
      search: `?${queryParams.toString()}`,
    });
  };
  const setMultipleParameters = (parameterName: string, value: string) => {
    const parameter = queryParams.get(parameterName) ?? "";
    if (parameter.includes(value)) {
      const filteredValue = parameter
        .split(",")
        .filter((param) => !param.includes(value));
      if (!filteredValue.length) {
        queryParams.delete(parameterName);
      } else {
        const finalValue =
          filteredValue.length > 1 ? filteredValue.join(",") : filteredValue[0];
        queryParams.set(parameterName, finalValue);
      }
    } else {
      const newParam = parameter.length ? `${parameter},${value}` : value;
      queryParams.set(parameterName, newParam);
    }
    history.replace({
      pathname,
      search: `?${queryParams.toString().replaceAll("%2C", ",")}`,
    });
  };

  const iterateOverParameters = (parameters: {
    [key: string]: Set<string>;
  }) => {
    const queryParams = Object.keys(parameters).reduce((acc, value) => {
      const values = Array.from(parameters[value]).join(",");
      if (values.length > 0) {
        acc.set(value, values);
      }
      return acc;
    }, new URLSearchParams());
    history.replace({
      pathname,
      search: `?${queryParams.toString().replaceAll("%2C", ",")}`,
    });
  };

  const clearParams = () => {
    history.replace({ pathname });
  };

  const createShipmentSubmitQueryParams = (tab: string) => {
    const [channel, ...rest] = pathname.split("/")[1].split("-");

    let wholesalePriceUrlParam = '';
    if (rest[rest.length-1] === WHOLESALE_PRICE_SUFFIX) {
      rest.pop();  // makes existing UNITS flow business models validation work with the wholesale price flow
      wholesalePriceUrlParam = '&qt=AMT'
    }


    const businessModel = FE_TO_BE_VALUES[ROUTE_TO_FE_VALUE[rest.join("-")]];
    return `${search}${wholesalePriceUrlParam}&${CHANNEL_PARAM}=${channel.toUpperCase()}&${BUSINESS_MODEL_PARAM}=${businessModel.toUpperCase()}&currForecast=${getISODateWithoutTime(
      shipmentMonthDate.getMonth(),
      shipmentMonthDate.getFullYear(),
    )}&${PRODUCT_ENGINE_PARAM}=${tab}`;
  };
  return {
    search,
    queryParams,
    clearParams,
    createShipmentSubmitQueryParams,
    iterateOverParameters,
    setParameter,
    setMultipleParameters,
  };
};
export default useQueryParams;
